import React from 'react';
import PropTypes from "prop-types";
import {Link, withRouter} from 'react-router-dom';
import {PAGES} from '../common/Shared';
import {connect} from 'react-redux';
import {iconCheck, iconWarning} from '../common/Icon';
import {joinClassNames} from 'dts-react-common';

const propTypes = {
	accepted: PropTypes.bool.isRequired,
	guid: PropTypes.string.isRequired,
	history: PropTypes.object.isRequired,
	offer: PropTypes.object,
	rejected: PropTypes.bool.isRequired,
};

const defaultProps = {
	offer: undefined,
};

const mapStateToProps = (state) => {
	return {
		accepted: state.app.accepted,
		offer: state.app.offer,
		rejected: state.app.rejected,
	};
};

class Menu extends React.Component {
	constructor(props) {
		super(props);

		this.props.history.listen((location, action) => {
			this.forceUpdate();
		});
	}

	setSelectedClassName(page) {
		let retVal;
		const path = window.location.pathname;
		let pageFromUrl = /^\/(.+)\//.exec(path);
		pageFromUrl = pageFromUrl.length > 1 ? pageFromUrl[1] : '';
		if (page === pageFromUrl) {
			retVal = 'selected';
		}
		return retVal;
	}

	completedDirectDeposit() {
		let retVal = false;
		if (this.props.offer && this.props.offer.guid) {
			retVal = this.props.offer.directDepositRoutingNumber && this.props.offer.directDepositAccountNumber && this.props.offer.directDepositAccountType;
		}
		return retVal;
	}

	completedOfferAcceptance() {
		let retVal = false;
		if (this.props.offer && this.props.offer.guid) {
			retVal = (this.props.accepted || this.props.rejected);
		}
		return retVal;
	}

	render() {
		return (this.props.offer && this.props.offer.guid) ? (
			<ul className="menu">
				<li>
					<Link to={`/${PAGES.CONDITIONS}/${this.props.guid}`}
						  className={this.setSelectedClassName(PAGES.CONDITIONS)}
					>
						1. Conditions of Employment {iconCheck()}
					</Link>
				</li>
				<li>
					<Link to={`/${PAGES.DIRECT_DEPOSIT}/${this.props.guid}`}

						  className={this.setSelectedClassName(PAGES.DIRECT_DEPOSIT)}
					>
						2. Direct Deposit {this.completedDirectDeposit() || this.props.accepted ? iconCheck() : iconWarning()}
					</Link>
				</li>
				<li>
					<Link to={`/${PAGES.OFFER_ACCEPTANCE}/${this.props.guid}`}
						  className={this.setSelectedClassName(PAGES.OFFER_ACCEPTANCE)}
					>
						3. Offer Acceptance {this.completedOfferAcceptance() ? iconCheck() : iconWarning()}
					</Link>
				</li>
				<li>
					<Link to={`/${PAGES.FIRST_DAY}/${this.props.guid}`}
						  onClick={(e) => {
							  !this.props.accepted && e.preventDefault();
						  }}
						  className={joinClassNames(
							  this.setSelectedClassName(PAGES.FIRST_DAY),
							  !this.props.accepted ? 'disabled' : undefined
						  )}
					>
						4. First Day of Work {this.props.accepted ? iconCheck() : iconWarning()}
					</Link>
				</li>
			</ul>
		) : null;
	}
}

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

export default withRouter(connect(mapStateToProps)(Menu));